import Actions from '../actions/actions';
import { emailAccountCRUDActions as EmailAccountCRUDActions } from '../actions/EmailAccountCRUDActions';
import { EmailAccount, EmailAccounts } from '../interfaces/emailAccount';
import {
  retrieved,
  retrievedAll,
  setBusy,
  setUnBusy,
  update,
} from './common/commonReducers';

interface ActionType {
  type: string;
  entity: EmailAccount;
  payload?: any;
}

const initialState: EmailAccounts = {
  entities: [],
};

// eslint-disable-next-line default-param-last
export const emailAccounts = (state = initialState, action: ActionType) => {
  switch (action.type) {
    case EmailAccountCRUDActions.busyAction:
      return setBusy(state);
    case EmailAccountCRUDActions.retrievedAllAction:
      return retrievedAll(state, action, false);
    case EmailAccountCRUDActions.updateAction:
      return update(state, action);
    case EmailAccountCRUDActions.retrievedAction:
      return retrieved(state, action);
    case EmailAccountCRUDActions.deleteLocalAction: {
      const entities = state.entities.filter(
        account => account.id !== action.entity.id,
      );
      return {
        ...state,
        entities,
        busy: false,
      };
    }
    case EmailAccountCRUDActions.unbusyAction:
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
};
